import { request } from '../../lib/request_mock';

// 获得有权限的菜单
export function getRouterList(data) {
    return request({
        url: '/menu/navigate',
        method: 'post',
        data,
    });
}
